
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';

const classNames = mergeStyleSets({
    Dialog: {
    }
});

const DialogButton = ({disabled, onClick, primary, title, value}) => {

    const handleClick = () => {
        if (onClick) {
            onClick(value);
        }
    }

    return (primary)
        ? <PrimaryButton disabled={disabled} text={title} onClick={handleClick} />
        : <DefaultButton disabled={disabled} text={title} onClick={handleClick} />;
}

const DialogBase = ({children, buttons, minWidth, open, onDismiss, title, type}) => {

    const handleClose = () => {
        if (onDismiss) {
            onDismiss(false);
        }
    }

    const handleCloseClick = (value) => {
        if (onDismiss) {
            onDismiss(value);
        }
    }

    const renderButtons = () => {
        buttons = buttons || [{primary: true, title: 'Zavřít', value: false}]

        return buttons.map((item, index) => {
            return (
                <DialogButton {...item} key={index} onClick={handleCloseClick} />
            );
        });
    }

    return (
        <Dialog
            hidden={!open}
            minWidth={minWidth}
            dialogContentProps={{
                type: type || DialogType.normal,
                title: title
            }}
            modalProps={{
                isBlocking: true,
                dragOptions: {}
            }}
            onDismiss={handleClose}
        >
            <Stack className={classNames.Dialog}>
                {children}
            </Stack>
            <DialogFooter>
                {renderButtons()}
            </DialogFooter>
        </Dialog>
    );
}

export default DialogBase;
